/** Convierte el input «Máx. filas» del editor a limit del spec (null = sin tope). */
export function rowLimitInputToSpecLimit(rowLimit) {
  if (rowLimit === '' || rowLimit === null || rowLimit === undefined) return null;
  const n = parseInt(String(rowLimit).trim(), 10);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.min(n, 5000);
}

/** Restaura el input del editor desde limit guardado en visualizationSpec. */
export function specLimitToRowLimitInput(limit) {
  if (limit === null || limit === undefined || limit === '' || limit === 0) return '';
  const n = parseInt(limit, 10);
  if (!Number.isFinite(n) || n <= 0) return '';
  return n;
}
